module.exports = __webpack_public_path__ + "static/media/cesnet-logo.865754aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/installfest/resources/sponsors/cesnet-logo.png
// module id = 404
// module chunks = 0